import { contactDraft } from './contact-draft.js';

const form = document.getElementById('contact-form');
const status = document.getElementById('contact-status');
form?.addEventListener('submit', event => {
  event.preventDefault();
  const select = form.elements.namedItem('enquiry_type');
  const label = select.selectedOptions[0]?.textContent;
  window.location.href = contactDraft(new FormData(form), label);
  // Preserve the form: opening a mail handler cannot confirm a sent message.
  status.textContent = 'Send your message from your email app. If no draft opens, use the email link below.';
});
